export const companyInfo = {
  name: "JPR Customs",
  tagline: "Paint Panel Restorations",
  phone: "+61 417 119 544",
  email: "admin@jprcustoms.com.au",
  address: "13 Hindmarsh Rd, Murray Bridge SA 5253",
  logo: "https://lirp.cdn-website.com/10fc801d/dms3rep/multi/opt/JPR+Customs-Logo-1920w.png",
  logoSmall: "https://lirp.cdn-website.com/10fc801d/dms3rep/multi/opt/JPR+Customs-Logo-240w.png",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100075571521893",
    instagram: "https://www.instagram.com/j.p.r.customs",
    linkedin: "https://www.linkedin.com/in/j-p-r-customs-291976167"
  },
  hours: {
    weekdays: "8:30 - 16:30",
    weekend: "Closed"
  }
};

export const heroContent = {
  title: "Car Spray Painting, Crash Repairs & Panel Beating in Murray Bridge, SA",
  description: "JPR Customs provides expert car spray painting, crash repairs, panel beating, custom paint work, and vehicle restoration services in Murray Bridge, SA. We're passionate about transforming automotive dreams into stunning realities. Call us now for a free quote.",
  backgroundImage: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1920&q=80"
};

export const whyChooseUs = [
  {
    id: 1,
    icon: "Search",
    title: "Attention to Detail",
    description: "We see what others miss."
  },
  {
    id: 2,
    icon: "Star",
    title: "Premium Materials and Craftsmanship",
    description: "We never compromise on quality."
  },
  {
    id: 3,
    icon: "Award",
    title: "Decades of Experience",
    description: "Our team can tackle any project."
  },
  {
    id: 4,
    icon: "Settings",
    title: "Cutting-Edge Facilities",
    description: "Our system guarantees a flawless finish."
  },
  {
    id: 5,
    icon: "Trophy",
    title: "Concours-Quality Restorations",
    description: "We bring your car back to its original glory."
  },
  {
    id: 6,
    icon: "Wrench",
    title: "Comprehensive Services",
    description: "We do it all, including custom paint jobs."
  },
  {
    id: 7,
    icon: "Car",
    title: "Vehicle and Part Sourcing",
    description: "We can find the perfect parts for you."
  },
  {
    id: 8,
    icon: "Users",
    title: "Satisfied Customers",
    description: "We are committed to excellence."
  }
];

export const services = [
  {
    id: 1,
    title: "Vintage and Classic Restoration Services",
    subtitle: "Breathtaking colors of our planet",
    image: "https://images.unsplash.com/photo-1591278169757-deac26e49555?w=800&q=80",
    link: "/restoration-services"
  },
  {
    id: 2,
    title: "Crash Repairs and Insurance Claims",
    subtitle: "Professional collision repair services",
    image: "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?w=800&q=80",
    link: "/crash-repairs"
  },
  {
    id: 3,
    title: "Vehicle Accessories – Trays, Canopies and Bull Bars",
    subtitle: "Quality accessories for your vehicle",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    link: "/vehicle-accessories"
  },
  {
    id: 4,
    title: "Paint Resprays and Custom Paint Work",
    subtitle: "Visual odyssey across continents",
    image: "https://images.unsplash.com/photo-1512080482556-ea648017576c?w=800&q=80",
    link: "/custom-paint"
  },
  {
    id: 5,
    title: "Towing Services",
    subtitle: "24/7 reliable towing assistance",
    image: "https://images.unsplash.com/photo-1562939753-a4f93f4d31a1?w=800&q=80",
    link: "/towing"
  },
  {
    id: 6,
    title: "Mechanical Repairs",
    subtitle: "Expert mechanical services and maintenance",
    image: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&q=80",
    link: "/mechanical-repairs"
  }
];

export const aboutContent = {
  tradition: {
    title: "Tradition of Automotive Excellence",
    description: "JPR Customs is a family-owned and operated business. We bring generations of experience and unwavering dedication to every project, from minor touch-ups to complete concours-quality restorations. We treat your car like our own, ensuring every detail receives the utmost attention and care.",
    image: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=800&q=80"
  },
  quality: {
    title: "Quality is Our Cornerstone",
    description: "We use only the highest quality materials and employ certified tradespeople with decades of experience. Our state-of-the-art paint booth and colour tinting system guarantee a flawless finish, while our spectro-colour matching service ensures perfect colour accuracy. We handle all freight and logistics with meticulous care.",
    image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=800&q=80"
  }
};

export const servicesList = [
  "Vintage and Classic Car Restoration",
  "Crash Repairs and Insurance Claims",
  "Vehicle Accessories",
  "Paint Resprays and Custom Paint Work",
  "Ski Boat and RV Resprays",
  "Towing Services",
  "Mechanical Repairs"
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Restoration Services", path: "/restoration-services" },
  { name: "Crash Repairs", path: "/crash-repairs" },
  { name: "Vehicle Accessories", path: "/vehicle-accessories" },
  { name: "Custom Paint Work", path: "/custom-paint" },
  { name: "Ski Boat & RV", path: "/ski-boat-rv" },
  { name: "Towing Services", path: "/towing" },
  { name: "Mechanical Repairs", path: "/mechanical-repairs" },
  { name: "Gallery", path: "/gallery" },
  { name: "Contact Us", path: "/contact" }
];
